<div class="title-container">
    <h1>{{ title }}</h1>
    <span class="subtitle">{{ subtitle }}</span>
  </div>
  